import React, { useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { Link, useSearchParams } from 'react-router-dom';
import ArchivedRmaList from './components/ArchivedRmaList.jsx';
import { useArchivedRmas } from './hooks/useArchivedRmas';
import NoAccessNotice from './components/NoAccessNotice';

const TABS = [
  { key: 'archived', label: 'Archived' },
  { key: 'cancelled', label: 'Prematurely closed' }
];

export default function RmaArchivePage() {
  const { user, isSignedIn } = useUser();
  const [searchParams] = useSearchParams();
  const highlightRmaId = searchParams.get('rmaId') || null;
  const role = user?.publicMetadata?.role || 'guest';
  const isAdmin = role === 'admin';
  const normalizedRole = String(role).toLowerCase().trim();
  const isService = normalizedRole.startsWith('service');
  const canView = isAdmin || isService;

  const [tab, setTab] = useState('archived');

  const archived = useArchivedRmas({ enabled: canView && tab === 'archived' });
  const cancelled = useArchivedRmas({
    path: 'rma-cancelled',
    enabled: canView && tab === 'cancelled'
  });

  const active = tab === 'cancelled' ? cancelled : archived;

  if (!isSignedIn || (!isAdmin && !isService)) {
    return (
      <div className="ni-page">
        <div className="ni-shell ni-shell--narrow">
          <NoAccessNotice pageName="the RMA archive" />
        </div>
      </div>
    );
  }

  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <header className="ni-header">
          <div className="ni-brand">
            <Link to="/" title="Back to main page" aria-label="Back to main page" style={{ display: 'inline-flex', lineHeight: 0 }}>
              <img src="/north-invent-logo.svg" alt="North Invent" className="ni-brand-logo" />
            </Link>
            <div className="ni-brand-copy">
              <span className="ni-eyebrow">Archive</span>
              <span className="ni-brand-subtitle">Closed RMA history and recovery</span>
            </div>
          </div>
        </header>

        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
          {TABS.map(t => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`ni-button ${tab === t.key ? 'ni-button--primary' : 'ni-button--ghost'}`}
              style={{ fontSize: '0.85rem' }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="ni-panel">
          <ArchivedRmaList
            items={active.items}
            isLoading={active.isLoading}
            error={active.error}
            onRetry={active.refetch}
            showPdfLink={tab === 'archived'}
            emptyMessage={
              tab === 'cancelled'
                ? 'No prematurely closed RMA cases.'
                : 'No archived RMA cases found.'
            }
            highlightRmaId={tab === 'archived' ? highlightRmaId : null}
          />
        </div>
      </div>
    </div>
  );
}
